import { Genealogy } from "./Genealogy";
import { GradingComment } from "./GradingComment";
import { Comment } from "./Comment";
import { LabResult } from "./LabResult";
import { LotRevision } from "./LotRevision";
import { Package } from "./Package";
import { QIR } from "./QIR";
import { Quality } from "./LotDetailQuality";
import { RelatedLot } from "./RelatedLot";
import { DateTime } from "luxon";
import { Batch } from "./Batch";
import { Packout } from "./Packout";

export interface Lot {
    summary: LotSummary,
    warnings: Warning[],
    qualities: Quality[],
    labResults: LabResult[],
    qirs: QIR[],
    revisions: LotRevision[],
    packages: Package[],
    comments: Comment[],
    gradingComments: GradingComment[],
    genealogy: Genealogy[] | null,
    excludeLabResults: string[],
    includeLabResults: string[],
    relatedLots: RelatedLot[],
    batches: Batch[],
    packouts: Packout[],
    [field: string]: unknown;
};

export interface LotSummary {
    lotNumber: string,
    businessUnitCode: string,
    businessUnitId: number,
    latestRevisionId: number,
    currentStatus: LotStatus,
    processingStatus: ProcessingStatus,
    buildStartUtc: DateTime | null,
    buildEndUtc: DateTime | null,
    grade: string,
    packoutGrade: string,
    materialCode: string,
    packageType: string,
    productionLine: string,
    extruder: string,
    isSplitLotParent: boolean,
    isLocked: boolean,
    shouldSendReleaseSample: boolean,
    shouldSendProductWriteOn: boolean,
    productWriteOnSentUtc: DateTime | null,
    data: {
        rftCode?: string,
        headerText?: string,
        packageCount?: number,
        qirCount?: number,
        [field: string]: unknown;
    }
    [field: string]: unknown;
}

export enum LotStatus {
    Imported = "Imported",
    Pending = "Pending",
    Processing = "Processing",
    ReadyToReview = "ReadyToReview",
    ReadyToGrade = "ReadyToGrade",
    Graded = "Graded",
}

export enum ProcessingStatus {
    Queued = "Queued",
    Processing = "Processing",
    Completed = "Completed",
    Failed = "Failed"
}

export const defaultLot: Lot = {
    summary: {
        lotNumber: "",
        businessUnitCode: "",
        businessUnitId: 0,
        currentStatus: LotStatus.Pending,
        processingStatus: ProcessingStatus.Completed,
        latestRevisionId: 0,
        buildStartUtc: null,
        buildEndUtc: null,
        grade: "",
        packoutGrade: "",
        materialCode: "",
        packageType: "",
        extruder: "",
        productionLine: "",
        isSplitLotParent: false,
        isLocked: false,
        shouldSendReleaseSample: true,
        data: {
        }
    },
    relatedLots: [],
    warnings: [],
    qualities: [],
    labResults: [],
    qirs: [],
    revisions: [],
    comments: [],
    gradingComments: [],
    includeLabResults: [],
    excludeLabResults: [],
    packages: [],
    genealogy: [],
    batches: []
};

export interface Warning {
    message: string,
    category: string,
}

export interface CreateNewLot {
    lotNumber: string,
    businessUnitId: Number,
    recipeId: Number,
    buildStartUtc: DateTime,
    buildEndUtc: DateTime
}